var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterRtl = function SvgFilterRtl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 20.5c0-1.933 1.673-3.5 3.736-3.5h58.528l.11.002c2.013.054 3.626 1.6 3.626 3.498 0 1.933-1.673 3.5-3.736 3.5H21.236l-.11-.002c-2.013-.054-3.626-1.6-3.626-3.498M36.26 46c-2.076 0-3.76 1.567-3.76 3.5 0 1.898 1.624 3.444 3.65 3.499l.11.001h43.48c2.077 0 3.76-1.567 3.76-3.5 0-1.898-1.624-3.444-3.65-3.498L79.74 46zm12.991 30c-2.071 0-3.751 1.567-3.751 3.5 0 1.898 1.62 3.444 3.64 3.499l.111.001H79.75c2.071 0 3.751-1.567 3.751-3.5 0-1.898-1.62-3.444-3.64-3.499L79.748 76z"
  })));
};
export default SvgFilterRtl;